import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';

import './ButtonBar.css';

function ButtonBar({ showAllButton, openNewEntryPopup }) {
  const location = useLocation();
  const [activeButton, setActiveButton] = useState('Statisch');
  const [canCreate, setCanCreate] = useState(false);
  const currentPage = location.pathname;

  const can_read_machine_configuration = JSON.parse(window.localStorage.getItem('can_read_machine_configuration'));

  // Variablen, um den NEU-Button bei canCreate=false nicht anzuzeigen
  const can_create_machinetype = JSON.parse(window.localStorage.getItem('can_create_machinetype'));
  const can_create_machine_configuration = JSON.parse(window.localStorage.getItem('can_create_machine_configuration'));
  const can_create_yarn = JSON.parse(window.localStorage.getItem('can_create_yarn'));
  const can_create_contactingrecipe = JSON.parse(window.localStorage.getItem('can_create_contactingrecipe'));


  useEffect(() => {
    if (currentPage === '/knittingmachinetype') {
      setActiveButton('Statisch');
      setCanCreate(can_create_machinetype)    
    } else if (currentPage === '/knittingmachineconfiguration') {
      setActiveButton('Veränderbar');
      setCanCreate(can_create_machine_configuration)
    } else if (currentPage === '/yarn') {
      setCanCreate(can_create_yarn)
    } else if (currentPage === '/basicyarn') {
      setCanCreate(can_create_yarn)
    } else if (currentPage === '/contactingrecipe') {
      setCanCreate(can_create_contactingrecipe)
    } else if (currentPage === '/administration') {
      setCanCreate(true)
    }
  }, [currentPage, can_create_machinetype, can_create_machine_configuration, can_create_yarn, can_create_contactingrecipe]);

  
  // Funktion zum Oeffnen eines Popup-Fensters basierend auf der aktuellen Seite
  const openPopupBasedOnPage = () => {
    // Aufruf der Funktion in MainLayout mit Uebergabe der aktuellen Seite
    openNewEntryPopup(currentPage);
  };

  // Dynamische Anpassung des margin-left der choice-button (statisch/veraenderbar) basierend auf der currentPage
  // jetzt nur noch für MaschinetypePage
  const pageStyles = {
    '/knittingmachinetype': {
      marginLeft: '0px',
    },
  };

  const choiceButtonStyle = {
    // Fallback-Wert von '0px', falls keine spezifischen Style-Anpassungen für die Seite vorhanden sind
    marginLeft: pageStyles[currentPage]?.marginLeft || '0px',
  };

  // Ueberpruefen, ob alle Buttons oder nur der new-button angezeigt werden sollen
  const showAll = showAllButton || false;


  return (
    <div className='button-bar'>
      {showAll ? (
        <>
          <div className='choice-button'>
            <Link to="/knittingmachinetype">
              <button 
                style={choiceButtonStyle} 
                className={activeButton === 'Statisch' ? 'active' : ''} 
                onClick={() => {
                  const previousPage = window.localStorage.getItem('previousPage');

                  if (previousPage !== '/knittingmachineconfiguration') {
                    window.localStorage.setItem('id_machinetype', 0); // Keine Zeile markiert
                  }
                  setActiveButton('Statisch');
                }}>
                  Statisch
              </button>
            </Link>
            {can_read_machine_configuration && (
              <Link to="/knittingmachineconfiguration">
                <button 
                  style={choiceButtonStyle} 
                  className={activeButton === 'Veränderbar' ? 'active' : ''} 
                  onClick={() => setActiveButton('Veränderbar')}>
                    Veränderbar
                </button>
              </Link>
            )}
          </div>
          <div className={`new-button ${!canCreate ? 'disabled' : ''}`}>
            <button onClick={openPopupBasedOnPage}>NEU</button>
          </div>
        </>
      ) : (
        <div className={`new-button ${!canCreate ? 'disabled' : ''}`}>
          <button onClick={openPopupBasedOnPage}>NEU</button>
        </div>
      )}
    </div>
  )
}

export default ButtonBar
